// extracted by mini-css-extract-plugin
export default {"container":"Hero_container__wcOgy","container-lg":"Hero_container-lg__lYPBw","wrapper":"Hero_wrapper__dVoTb","title":"Hero_title__nSbe2"};